import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-klasse-sieben-page',
  templateUrl: './klasse-sieben-page.component.html',
  styleUrls: ['./klasse-sieben-page.component.css']
})
export class KlasseSiebenPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
